import { baseConfig } from '@adornis/config/baseConfig';
import type { TrackerInput } from './types/Tracker';

export const getMatomoOptions = (): TrackerInput => ({
  identifier: 'matomo-tracking',
  scripts: getScripts(),
});

function getScripts(): HTMLScriptElement[] {
  const rootURL = baseConfig.get('ROOT_URL');
  const siteID = {
    'https://digitale-helden-prelaunch-marketing.staging.adornis.de/': 11,
    'https://digitale-helden-campus.staging.adornis.de/': 10,
    'https://digitale-helden.de/': 4,
    'https://campus.digitale-helden.de/': 9,
    'https://lasdigitale-helden-michi-campus-runtime.nexus.adornis.de/': 12,
  }[rootURL];

  if (siteID === undefined) throw new Error(`No matomo tracking script defined for url '${rootURL}'`);

  /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
  const trackingScript = document.createElement('script');
  // @ts-expect-error matomo internal state
  var _paq = (window._paq = window._paq || []);
  _paq.push(['setExcludedQueryParams', ['email']]);
  _paq.push(['enableLinkTracking']);
  const matomoURL = 'https://piwik.digitale-helden.de/';
  const matomoPhpUrl = 'https://piwik.digitale-helden.de/matomo.php';
  _paq.push(['setTrackerUrl', matomoPhpUrl]);
  _paq.push(['setSiteId', `${siteID}`]);

  if (siteID === 4 || siteID === 9) {
    _paq.push(['addTracker', matomoPhpUrl, '13']);
  }

  trackingScript.src = `${matomoURL}matomo.js`;

  /* matomo tag manager script */
  const tagManagerScript = document.createElement('script');
  tagManagerScript.src = 'https://piwik.digitale-helden.de/js/container_T929TW2B.js';

  return [trackingScript, tagManagerScript];
}
